/**
 * Тип заданий
 */
export default class TasksStateTypesEnums
{
    /**
     * Предустановленный
     */
    public static readonly STATE_PRESET_TYPE = 1;
    /**
     * Кастомный
     */
    public static readonly STATE_CUSTOM_TYPE = 2;
}
